import { ConfigProvider, theme } from "antd";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import MainLayout from "./components/Layout";
import Notification from "./pages/AddNotification";
import Admin from "./pages/Admin";
import Album from "./pages/Album";
import Artists from "./pages/Artists";
import Banner from "./pages/Banner";
import Categories from "./pages/Categories";
import Genres from "./pages/Genres";
import Home from "./pages/Home";
import LoginForm from "./pages/Login";
import Music from "./pages/Music";
import RedeemRequest from "./pages/RedeemRequest";
import Subscription from "./pages/Subscription";
import SystemValues from "./pages/SystemValues";
import UploadRequest from "./pages/UploadRequest";
import Users from "./pages/Users";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#16a34a",
        },
        algorithm: theme.darkAlgorithm,
      }}
    >
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <Home />
            </MainLayout>
          }
        />
        <Route
          path="/notifications"
          element={
            <MainLayout>
              <Notification />
            </MainLayout>
          }
        />
        <Route
          path="/upload-request"
          element={
            <MainLayout>
              <UploadRequest />
            </MainLayout>
          }
        />
        <Route
          path="/admins"
          element={
            <MainLayout>
              <Admin />
            </MainLayout>
          }
        />
        <Route
          path="/banners"
          element={
            <MainLayout>
              <Banner />
            </MainLayout>
          }
        />
        <Route
          path="/systemvalues"
          element={
            <MainLayout>
              <SystemValues />
            </MainLayout>
          }
        />
        <Route
          path="/music"
          element={
            <MainLayout>
              <Music />
            </MainLayout>
          }
        />
        <Route
          path="/users"
          element={
            <MainLayout>
              <Users />
            </MainLayout>
          }
        />
        <Route
          path="/categories"
          element={
            <MainLayout>
              <Categories />
            </MainLayout>
          }
        />
        <Route
          path="/subs"
          element={
            <MainLayout>
              <Subscription />
            </MainLayout>
          }
        />
        <Route
          path="/genres"
          element={
            <MainLayout>
              <Genres />
            </MainLayout>
          }
        />
        <Route
          path="/artists"
          element={
            <MainLayout>
              <Artists />
            </MainLayout>
          }
        />
        <Route
          path="/album"
          element={
            <MainLayout>
              <Album />
            </MainLayout>
          }
        />
        <Route path="/login" element={<LoginForm />} />
        <Route
          path="/redeem-requests"
          element={
            <MainLayout>
              <RedeemRequest />
            </MainLayout>
          }
        />
      </Routes>
    </ConfigProvider>
  );
}

export default App;
